export const TENANT_ROLE = 'tenant';
export const LANDLORD_ROLE = 'landlord';

export const ROLES = [TENANT_ROLE, LANDLORD_ROLE];
